import { Logger } from '@/helpers/log';

const logger = new Logger('store:amplify:widgets/dashboardWidgets');

function getById(resources, ref) {
  const id = (ref && typeof ref === 'object') ? ref.id : ref;
  if (id === undefined || id === null) {
    return undefined;
  }
  const resource = resources.find(({ id: rid }) => rid === id);
  if (resource === undefined) {
    logger.warn('Unable to find expected resource', id, resources);
  }
  return resource;
}

export function linkAggregate(spec, { filters, properties }, scope) {
  const { property, filter, ...settings } = spec;
  return {
    ...settings,
    property: getById(properties, property),
    filter: getById(filters, filter),
    scope,
  };
}
export function linkCohort(spec, { kpis }, scope) {
  const { kpi, ...settings } = spec;
  return {
    ...settings,
    kpi: getById(kpis, kpi),
    scope,
  };
}
export function linkEvent(spec, { filters }, scope) {
  const { incidentConfig, scopeConfig, ...settings } = spec;
  return {
    ...settings,
    incidentConfig: getById(filters, incidentConfig),
    scopeConfig: getById(filters, scopeConfig),
    scope,
  };
}
export function linkList(spec, { filters, kpis }, scope) {
  const { filter, kpi, ...settings } = spec;
  return {
    ...settings,
    filter: getById(filters, filter),
    kpi: getById(kpis, kpi),
    scope,
  };
}
export function linkMap(spec, { filters, properties }, scope) {
  const { filter, tooltipProperty, ...settings } = spec;
  let colouring;
  if (spec.colouring) {
    colouring = {
      ...spec.colouring,
      property: getById(properties, spec.colouring.property),
    };
  }

  let tooltipProperties = [];
  if (Array.isArray(spec.tooltipProperties)) {
    tooltipProperties = spec.tooltipProperties.map((p) => getById(properties, p));

    // Migrate from old tooltips to multi tooltips
    if (tooltipProperties.length === 0 && tooltipProperty) {
      const oldProperty = getById(properties, tooltipProperty);
      if (oldProperty) {
        tooltipProperties.push(oldProperty);
      }
    }
  }

  return {
    ...settings,
    filter: getById(filters, filter),
    tooltipProperty: getById(properties, tooltipProperty),
    tooltipProperties,
    colouring,
    scope,
  };
}
export function linkProperty(spec, { filters, properties }, scope) {
  const { property, scopeSearch, ...settings } = spec;
  return {
    ...settings,
    property: getById(properties, property),
    scopeSearch: getById(filters, scopeSearch),
    scope,
  };
}
export function linkStatus(spec, { filters }, scope) {
  const { testSearch, scopeSearch, ...settings } = spec;
  return {
    ...settings,
    testSearch: getById(filters, testSearch),
    scopeSearch: getById(filters, scopeSearch),
    scope,
  };
}
export function linkFloorplan(spec, { filters, properties }, scope) {
  const {
    filter, xProperty, yProperty, tooltipProperty, ...settings
  } = spec;

  let colouring;
  if (spec.colouring) {
    colouring = {
      ...spec.colouring,
      property: getById(properties, spec.colouring.property),
    };
  }

  return {
    ...settings,
    filter: getById(filters, filter),
    xProperty: getById(properties, xProperty),
    yProperty: getById(properties, yProperty),
    tooltipProperty: getById(properties, tooltipProperty),
    colouring,
    scope,
  };
}

export function linkDevice(spec, { properties }, scope) {
  const {
    displayedProperties, ...settings
  } = spec;

  return {
    ...settings,
    displayedProperties: displayedProperties.map((id) => getById(properties, id)),
    scope,
  };
}

export function linkWorkflow(spec, { properties }, scope) {
  const {
    workflowProperty, ...settings
  } = spec;

  return {
    ...settings,
    workflowProperty: getById(properties, workflowProperty),
    scope,
  };
}

export function linkAlarms(spec, _, scope) {
  const {
    ...settings
  } = spec;

  return {
    ...settings,
    scope,
  };
}
